// context/ScrollContextProvider.tsx

import React, {
  createContext,
  useContext,
  useEffect,
  useRef,
  useState,
} from 'react';

interface ScrollContextType {
  isScrolled: boolean;
  scrollRef: React.RefObject<HTMLDivElement | null>;
}

const ScrollContext = createContext<ScrollContextType | undefined>(undefined);

export const ScrollContextProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [isScrolled, setIsScrolled] = useState(false);
  const scrollRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const el = scrollRef.current;
    if (!el) return;
    const handleScroll = () => setIsScrolled(el.scrollTop > 10);
    el.addEventListener('scroll', handleScroll);
    return () => el.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <ScrollContext.Provider value={{ isScrolled, scrollRef }}>
      {children}
    </ScrollContext.Provider>
  );
};

// Export the Hook
export const useScrollContext = () => {
  const context = useContext(ScrollContext);
  if (!context)
    throw new Error(
      'useScrollContext must be used within ScrollContextProvider'
    );
  return context;
};
